import { Box, Skeleton, Stack } from '@mui/joy';

const BoxHistorySkeleton = () => {
  return (
    <Box
      sx={{
        p: 2,
        borderRadius: '12px',
        bgcolor: 'background.surface',
        boxShadow: 'sm',
        width: '100%',
      }}
    >
      <Stack direction='row' justifyContent='space-between' alignItems='center'>
        <Stack spacing={1}>
          <Skeleton variant='text' width={180} level='body-sm' />
          <Stack direction='row' alignItems='center' spacing={1}>
            <Skeleton variant='text' width={100} level='body-md' />
            <Skeleton variant='circular' width={16} height={16} />
            <Skeleton variant='text' width={60} level='body-md' />
          </Stack>
        </Stack>

        <Stack direction='column' alignItems='center' spacing={1}>
          <Skeleton variant='text' width={280} level='body-md' />
          <Skeleton variant='text' width={280} level='body-md' />
        </Stack>
      </Stack>
    </Box>
  );
};

export default BoxHistorySkeleton;
